import { Directive, inject } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { PrimengDialogDirective } from './primeng-dialog.directive';

@Directive({
  selector: '[appPrimengDialogRightSheet]',
  hostDirectives: [PrimengDialogDirective],
})
export class PrimengDialogRightSheetDirective {
  private readonly dialog = inject(Dialog);

  public constructor() {
    this.configureBottomSheetDialog();
  }

  private configureBottomSheetDialog(): void {
    this.dialog.position = 'right';
    this.dialog.breakpoints = [];
    this.dialog.style = {
      ...this.dialog.style,
      width: '40vw',
      height: '100vh',
      maxHeight: '100vh',
      margin: '0',
    };
  }
}
